/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerChangeType,
  CashDrawerChangeTypeOptional,
  CashDrawerChangeTypeMetaI,
  CashDrawerChangeTypeTrackedI,
} from "./cash-drawer-change-type";
import {
  CashDrawerChangeTypeTracked,
  CashDrawerChangeTypeMeta,
} from "./cash-drawer-change-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerRef,
  CashDrawerRefOptional,
  CashDrawerRefMetaI,
  CashDrawerRefTrackedI,
} from "./cash-drawer-ref";
import { CashDrawerRefTracked, CashDrawerRefMeta } from "./cash-drawer-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawersChangeFull,
  CashDrawersChangeFullOptional,
  CashDrawersChangeFullMetaI,
  CashDrawersChangeFullTrackedI,
} from "./cash-drawers-change-full";
import {
  CashDrawersChangeFullTracked,
  CashDrawersChangeFullMeta,
} from "./cash-drawers-change-full";

/**
 *
 * @export
 * @interface CashDrawersChangeDTO
 */
export interface CashDrawersChangeDTOOptional extends CashDrawersChangeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CashDrawersChangeDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashDrawersChangeDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  assignId?: number;
  /**
   *
   * @type {CashDrawerChangeType}
   * @memberof CashDrawersChangeDTO
   */
  changeType?: CashDrawerChangeType;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  amountCents?: number;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  amountTendered?: number;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof CashDrawersChangeDTO
   */
  cashDrawerId?: CashDrawerRefOptional;
}

export interface CashDrawersChangeDTO
  extends CashDrawersChangeDTOOptional, CashDrawersChangeFull {
  /**
   *
   * @type {boolean}
   * @memberof CashDrawersChangeDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashDrawersChangeDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  assignId: number;
  /**
   *
   * @type {CashDrawerChangeType}
   * @memberof CashDrawersChangeDTO
   */
  changeType: CashDrawerChangeType;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  amountCents: number;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  amountTendered?: number;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof CashDrawersChangeDTO
   */
  cashDrawerId?: CashDrawerRef;
}

export interface CashDrawersChangeDTOTrackedI extends CashDrawersChangeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CashDrawersChangeDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashDrawersChangeDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {CashDrawerChangeType}
   * @memberof CashDrawersChangeDTO
   */
  changeType?: CashDrawerChangeType;
  changeTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CashDrawersChangeDTO
   */
  amountTendered?: number;
  amountTenderedIsSet: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof CashDrawersChangeDTO
   */
  cashDrawerId?: CashDrawerRefTrackedI;
  cashDrawerIdIsSet: boolean;
}

transformDatesMap.set(
  "CashDrawersChangeDTO",
  function (model: CashDrawersChangeDTO) {
    const transformDatescashDrawerId = transformDatesMap.get("CashDrawerRef");
    if (transformDatescashDrawerId && model.cashDrawerId) {
      transformDatescashDrawerId(model.cashDrawerId);
    }
  },
);

export type CashDrawersChangeDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  changeType: PropertyMeta<CashDrawerChangeTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTendered: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  cashDrawerId: PropertyMeta<CashDrawerRefMetaI>;
}>;

export var CashDrawersChangeDTOMeta: CashDrawersChangeDTOMetaI =
  {} as CashDrawersChangeDTOMetaI;
CashDrawersChangeDTOMeta = typeMeta("CashDrawersChangeDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  changeType: propertyMeta(
    "changeType",
    false,
    true,
    false,
    CashDrawerChangeTypeMeta,
  ),
  amountCents: propertyMeta(
    "amountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  amountTendered: propertyMeta(
    "amountTendered",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  cashDrawerId: propertyMeta(
    "cashDrawerId",
    false,
    false,
    false,
    CashDrawerRefMeta,
  ),
});

const metaI = CashDrawersChangeDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CashDrawersChangeFullMeta]);
  metaI.isDeleted.inheritedFrom = CashDrawersChangeFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = CashDrawersChangeFullMeta.isNew;
  metaI.assignId.inheritedFrom = CashDrawersChangeFullMeta.assignId;
  metaI.changeType.inheritedFrom = CashDrawersChangeFullMeta.changeType;
  metaI.amountCents.inheritedFrom = CashDrawersChangeFullMeta.amountCents;
  metaI.amountTendered.inheritedFrom = CashDrawersChangeFullMeta.amountTendered;
  metaI.cashDrawerId.inheritedFrom = CashDrawersChangeFullMeta.cashDrawerId;
});

export class CashDrawersChangeDTOTracked
  extends CashDrawersChangeFullTracked
  implements CashDrawersChangeDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  changeType__I?: CashDrawerChangeType = undefined;
  changeTypeIsSet: boolean = false;
  set changeType(v: undefined | CashDrawerChangeType) {
    if (v !== undefined) {
      this.changeType__I = v;
      this.changeTypeIsSet = true;
    } else {
      this.changeType__I = v || undefined;
      this.changeTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get changeType() {
    return this.changeType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  amountTendered__I?: number = undefined;
  amountTenderedIsSet: boolean = false;
  set amountTendered(v: undefined | number) {
    if (v !== undefined) {
      this.amountTendered__I = v;
      this.amountTenderedIsSet = true;
    } else {
      this.amountTendered__I = v || undefined;
      this.amountTenderedIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTendered() {
    return this.amountTendered__I;
  }
  cashDrawerId__I?: CashDrawerRefTracked = undefined;
  cashDrawerIdIsSet: boolean = false;
  set cashDrawerId(v: undefined | CashDrawerRefTracked) {
    if (v !== undefined) {
      this.cashDrawerId__I = v;
      this.cashDrawerIdIsSet = true;
    } else {
      this.cashDrawerId__I = v || undefined;
      this.cashDrawerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawerId() {
    return this.cashDrawerId__I;
  }
  constructor(config?: CashDrawersChangeDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.cashDrawerId?.setIds();
  }
  assignFrom(
    config: CashDrawersChangeDTOOptional,
    options?: AssignOptions,
  ): CashDrawersChangeDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.changeType &&
      this.changeTypeApplyFilter(optionsRequired.filter)
    ) {
      this.changeType = config.changeType;
      if (optionsRequired.unassign) this.changeTypeIsSet = false;
      else this.changeTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (
      config.amountTendered &&
      this.amountTenderedApplyFilter(optionsRequired.filter)
    ) {
      this.amountTendered = config.amountTendered;
      if (optionsRequired.unassign) this.amountTenderedIsSet = false;
      else this.amountTenderedIsSet = true;
    }
    if (
      config.cashDrawerId &&
      this.cashDrawerIdApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerId = new CashDrawerRefTracked(
        config.cashDrawerId,
        options,
      );
      if (optionsRequired.unassign) this.cashDrawerIdIsSet = false;
      else this.cashDrawerIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CashDrawersChangeDTOTrackedI {
    const cloned = {} as CashDrawersChangeDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.changeTypeIsSetDeep() &&
      this.changeTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.changeTypeIsSet = true;
      cloned.changeType = this.changeType;
    } else {
      //cloned.changeTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.amountTenderedIsSetDeep() &&
      this.amountTenderedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTenderedIsSet = true;
      cloned.amountTendered = this.amountTendered;
    } else {
      //cloned.amountTenderedIsSet = false
    }
    if (
      this.cashDrawerIdIsSetDeep() &&
      this.cashDrawerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerIdIsSet = true;
      cloned.cashDrawerId = this.cashDrawerId?.removeUnset(filter);
    } else {
      //cloned.cashDrawerIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CashDrawersChangeDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.changeTypeApplyFilter(filter)) this.changeTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.amountTenderedApplyFilter(filter))
      this.amountTenderedIsSet = false;

    if (!this.cashDrawerIdApplyFilter(filter)) this.cashDrawerIdIsSet = false;
    this.cashDrawerId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeDTOMeta.isDeleted,
      CashDrawersChangeDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeDTOMeta.isNew,
      CashDrawersChangeDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeDTOMeta.assignId,
      CashDrawersChangeDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  changeTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeDTOMeta.changeType,
      CashDrawersChangeDTOMeta,
      this.changeType,
      this,
    );
  }
  changeTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.changeTypeIsSet && this.changeTypeApplyFilter(filter)) return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeDTOMeta.amountCents,
      CashDrawersChangeDTOMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTenderedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeDTOMeta.amountTendered,
      CashDrawersChangeDTOMeta,
      this.amountTendered,
      this,
    );
  }
  amountTenderedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTenderedIsSet && this.amountTenderedApplyFilter(filter))
      return true;

    return false;
  }
  cashDrawerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawersChangeDTOMeta.cashDrawerId,
      CashDrawersChangeDTOMeta,
      this.cashDrawerId,
      this,
    );
  }
  cashDrawerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerIdIsSet && this.cashDrawerIdApplyFilter(filter))
      return true;
    return this.cashDrawerId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.changeTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.amountTenderedIsSetDeep(filter)) return true;
    if (this.cashDrawerIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
